import ToggleButtons from "../../../../../../../library/toggle-buttons";
import { getIcon } from "../../../../../../../utils/get-icon";
import { useSettings } from "../../../context";
import { FieldWrapper } from "./styled";

const FontDecorationConfiguration = () => {
  const { fonts, updateFontSettings, getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  const handleDecorationChange = (value: string) => {
    updateFontSettings({ decoration: value });
  };

  const handleVariantChange = (value: string) => {
    if (value === "bold") {
      updateFontSettings({ weight: "bold", variant: "normal" });
    } else {
      updateFontSettings({ variant: value, weight: "normal" });
    }
  };

  const renderItalicAvailable = () => {
    const selectedFont = fonts?.find(
      (font: any) => font.family === currentSettings.configuration.font.family
    );

    if (selectedFont) {
      const variants = selectedFont.variants;
      return !variants.some((variant: string) => variant?.includes("italic"));
    }

    return false;
  };

  const renderBoldAvailable = () => {
    const selectedFont = fonts?.find(
      (font: any) => font.family === currentSettings.configuration.font.family
    );

    if (selectedFont) {
      const variants = selectedFont.variants;
      return !variants.some((variant: string) => {
        const weight = parseInt(variant.replace(/\D/g, ""), 10);
        return weight >= 500;
      });
    }

    return false;
  };

  return (
    <>
      <FieldWrapper>
        <ToggleButtons
          selected={currentSettings.configuration.font.decoration}
          className="toggle-buttons"
          variant="secondary"
          options={[
            {
              title: (
                <>
                  {getIcon("dash")} <span>Ingen</span>
                </>
              ),
              value: "normal",
            },
            {
              title: (
                <>
                  {getIcon("underline")} <span>Under</span>
                </>
              ),
              value: "underline",
            },
            {
              title: (
                <>
                  {getIcon("strikethrough")} <span>Gjennom</span>
                </>
              ),
              value: "line-through",
            },
          ]}
          onSelect={handleDecorationChange}
        />
      </FieldWrapper>
      <FieldWrapper>
        <ToggleButtons
          selected={currentSettings.configuration.font.variant}
          className="toggle-buttons"
          variant="secondary"
          options={[
            {
              title: (
                <>
                  {getIcon("regular-text")} <span>Vanlig</span>
                </>
              ),
              value: "normal",
            },
            {
              title: (
                <>
                  {getIcon("italic-text")} <span>Kursiv</span>
                </>
              ),
              value: "italic",
              disabled: renderItalicAvailable(),
            },
            {
              title: (
                <>
                  {getIcon("bold-text")} <span>Uthevet</span>
                </>
              ),
              value: "bold",
              disabled: renderBoldAvailable(),
            },
          ]}
          onSelect={handleVariantChange}
        />
      </FieldWrapper>
    </>
  );
};
export default FontDecorationConfiguration;
